/**
 * /src/app.js
 */
import "../scss/style.scss";
import * as u from "./_util";
import "@splidejs/splide/css/core";
import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", () => {
  // 汎用的なタブ切り替え関数
  const setupTabs = tabContainerSelector => {
    const tabLists = document.querySelectorAll(tabContainerSelector);

    tabLists.forEach(tabList => {
      const tabs = tabList.querySelectorAll("a");
      if (tabs.length === 0) return;

      // このタブグループが管理するコンテンツ要素を取得
      const targets = Array.from(tabs)
        .map(tab => {
          const targetId = tab.getAttribute("href").substring(1);
          return document.getElementById(targetId);
        })
        .filter(el => el !== null);

      // 初期化処理：アクティブなタブのコンテンツを表示、他を非表示にする
      let activeTab = Array.from(tabs).find(t => t.classList.contains("is-active"));
      if (!activeTab && tabs.length > 0) {
        activeTab = tabs[0];
        activeTab.classList.add("is-active");
      }

      if (activeTab) {
        const initialTargetId = activeTab.getAttribute("href").substring(1);
        targets.forEach(content => {
          if (content.id === initialTargetId) {
            content.style.display = "block";
          } else {
            content.style.display = "none";
          }
        });
      }

      // クリックイベントの設定
      tabs.forEach(tab => {
        tab.addEventListener("click", e => {
          e.preventDefault();

          // アクティブクラスの切り替え
          tabs.forEach(t => t.classList.remove("is-active"));
          tab.classList.add("is-active");

          // コンテンツの表示・非表示を切り替え
          const targetId = tab.getAttribute("href").substring(1);
          targets.forEach(content => {
            if (content.id === targetId) {
              content.style.display = "block";
            } else {
              content.style.display = "none";
            }
          });
        });
      });
    });
  };

  // トーナメント表のタブ切り替え
  setupTabs(".p-home__tournament-tab");

  // 試合日程のタブ切り替え（階層別）
  setupTabs(".p-home__match__tab01");
  setupTabs(".p-home__match__tab02");
  setupTabs(".p-home__match__tab03");

  setupTabs(".p-schedule__tab");

  // ランキングページのタブ切り替え
  setupTabs(".p-ranking__tab");

  // ランキング「もっと表示する」は ranking.js で href / target を設定（ここでは preventDefault しない）

  // トーナメントブラケットの可変グリッド初期化
  const initTournamentBlocks = () => {
    // グリッドサイズ定義（モバイル / デスクトップ）
    const SPECS = {
      m: { playerCol: 159, roundCol: 69, winnerCol: 50, rows: [11, 11, 1, 1, 11, 11, 6, 6] },
      d: { playerCol: 237, roundCol: 103, winnerCol: 100, rows: [16, 16, 1, 1, 16, 16, 9, 9] },
    };
    const SPECS_DOUBLES = {
      m: { playerCol: 159, roundCol: 69, winnerCol: 50, rows: [22, 22, 1, 1, 22, 22, 6, 6] },
      d: { playerCol: 237, roundCol: 103, winnerCol: 100, rows: [37, 37, 1, 1, 37, 37, 9, 9] },
    };

    document.querySelectorAll(".p-tournament__block[data-players]").forEach(block => {
      const n = parseInt(block.getAttribute("data-players"), 10);
      if (!n || Math.log2(n) % 1 !== 0) return;

      const isDoubles = block.classList.contains("-doubles");
      const specs = isDoubles ? SPECS_DOUBLES : SPECS;
      const rounds = Math.log2(n); // ラウンド数（例: 64人=6）
      const pairs = n / 2; // 1回戦の対戦数（行グループ数）
      const roundCols = rounds + 1; // ラウンド列数＋決勝接続列
      const winnerCol = rounds + 3; // 優勝者列番号
      const seventhCol = rounds + 2; // 決勝接続線の列番号
      // 優勝者の行位置: 全行の中央（全行数 = pairs * 8）
      const mid = pairs * 4;
      const trophyRow = mid - 2;
      const nameRow = mid - 1;

      ["m", "d"].forEach(key => {
        const s = specs[key];
        const rowPat = s.rows.map(v => `${v}px`).join(" ");
        const gtc = `${s.playerCol}px repeat(${roundCols}, ${s.roundCol}px) ${s.winnerCol}px`;
        const gtr = `repeat(${pairs}, ${rowPat})`;
        const bw = `${s.playerCol + roundCols * s.roundCol + s.winnerCol}px`;
        block.style.setProperty(`--gtc-${key}`, gtc);
        block.style.setProperty(`--gtr-${isDoubles ? "d" + key : key}`, gtr);
        block.style.setProperty(`--bw-${key}`, bw);
      });

      block.style.setProperty("--col-w", winnerCol);
      block.style.setProperty("--row-trophy", trophyRow);
      block.style.setProperty("--row-winner", nameRow);
      block.style.setProperty("--row-winner-name", nameRow + 2);
      block.style.setProperty("--col-7", seventhCol);
      block.style.setProperty("--row-7", nameRow);
    });
  };

  initTournamentBlocks();

  // トーナメントページの上下タブを連動させる
  const topTabs = document.querySelectorAll(".p-tournament__tab--top a");
  const bottomTabs = document.querySelectorAll(".p-tournament__tab--bottom a");

  if (topTabs.length > 0 && bottomTabs.length > 0) {
    const allTabGroups = [topTabs, bottomTabs];
    const contents = document.querySelectorAll(".p-tournament__tab-content");

    const activateTab = targetId => {
      // 上下両方のタブのアクティブクラスを同期
      allTabGroups.forEach(tabs => {
        tabs.forEach(tab => {
          if (tab.getAttribute("href") === `#${targetId}`) {
            tab.classList.add("is-active");
          } else {
            tab.classList.remove("is-active");
          }
        });
      });

      // コンテンツの表示切り替え
      contents.forEach(content => {
        content.style.display = content.id === targetId ? "block" : "none";
      });
    };

    // 初期表示
    const initialActive = Array.from(topTabs).find(t => t.classList.contains("is-active"));
    const initialId = initialActive
      ? initialActive.getAttribute("href").substring(1)
      : topTabs[0].getAttribute("href").substring(1);
    activateTab(initialId);

    // クリックイベントを上下両方に設定
    allTabGroups.forEach(tabs => {
      tabs.forEach(tab => {
        tab.addEventListener("click", e => {
          e.preventDefault();
          activateTab(tab.getAttribute("href").substring(1));
        });
      });
    });
  }

  // スライダー

  const movieSlider = document.querySelector(".p-home__movie-slider");
  if (movieSlider) {
    new Splide(movieSlider, {
      type: "loop",
      mediaQuery: "min",
      pagination: true,
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    }).mount();
  }

  const interviewCards = document.querySelector(".p-home__interview__cards");
  if (interviewCards) {
    new Splide(interviewCards, {
      type: "loop",
      mediaQuery: "min",
      pagination: true,
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    }).mount();
  }

  const digestCards = document.querySelector(".p-home__digest__cards");
  // .no-slider がついている場合はスライダーを初期化しない
  if (digestCards && !digestCards.classList.contains("no-slider")) {
    new Splide(digestCards, {
      type: "loop",
      mediaQuery: "min",
      pagination: true,
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    }).mount();
  }
  // .no-slider がついている場合は12個(SP:6個)を初期表示
  if (digestCards && digestCards.classList.contains("no-slider")) {
    const initialCount = window.innerWidth < 768 ? 6 : 12;
    const slides = digestCards.querySelectorAll(".splide__slide");
    Array.from(slides).forEach((slide, index) => {
      slide.style.display = index < initialCount ? "block" : "none";
    });
  }

  // movieもっとみるボタン（no-sliderのときのみ：PC・SP共に4個ずつ表示）
  const movieMoreBtn = document.querySelector(".p-home__movie-btn a");
  if (movieMoreBtn && digestCards && digestCards.classList.contains("no-slider")) {
    movieMoreBtn.addEventListener("click", e => {
      e.preventDefault();

      const slides = document.querySelectorAll(".p-home__digest__cards .splide__slide");
      const hidden = Array.from(slides).filter(slide => window.getComputedStyle(slide).display === "none");

      hidden.slice(0, 4).forEach(slide => {
        u.fadeIn(slide, 300);
      });

      // 残りが0になったらボタンを非表示
      const remaining = Array.from(slides).filter(slide => window.getComputedStyle(slide).display === "none");
      if (remaining.length === 0) {
        movieMoreBtn.closest(".p-home__movie-btn").style.display = "none";
      }
    });
  }

  // プレイスタイルチャート
  const styleChart = document.querySelector(".p-detail__style-chart");
  if (styleChart) {
    const scores = [
      parseFloat(styleChart.dataset.score1) || 0,
      parseFloat(styleChart.dataset.score2) || 0,
      parseFloat(styleChart.dataset.score3) || 0,
      parseFloat(styleChart.dataset.score4) || 0,
      parseFloat(styleChart.dataset.score5) || 0,
    ];

    // SVG viewBox 332x316 におけるセンター（外周五角形の重心）
    const cx = 166.001;
    const cy = 174.51;
    const maxScore = 5;

    // スコア5のときの各頂点（HTMLのpath描画順: v4→v5→v1→v2→v3）
    const vertices = [
      { x: 63.79, y: 315.191, scoreIdx: 3 }, // score4: 左下
      { x: 0.621, y: 120.775, scoreIdx: 4 }, // score5: 左
      { x: 166.001, y: 0.62, scoreIdx: 0 }, // score1: 上
      { x: 331.381, y: 120.775, scoreIdx: 1 }, // score2: 右
      { x: 268.212, y: 315.191, scoreIdx: 2 }, // score3: 右下
    ];

    const points = vertices.map(v => {
      const ratio = scores[v.scoreIdx] / maxScore;
      return {
        x: cx + (v.x - cx) * ratio,
        y: cy + (v.y - cy) * ratio,
      };
    });

    const d = points.map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(3)} ${p.y.toFixed(3)}`).join("") + "Z";

    const path = styleChart.querySelector("svg path");
    if (path) path.setAttribute("d", d);
  }

  const grade2Cards = document.querySelector(".p-detail__grade2-list");
  if (grade2Cards) {
    new Splide(grade2Cards, {
      type: "loop",
      perPage: 4,
      gap: 27,
      pagination: true,
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    }).mount();
  }

  // interviewもっとみるボタン（PC時：4件ずつ表示）
  // const interviewMoreBtn = document.querySelector(".p-home__interview-btn a");
  // if (interviewMoreBtn) {
  //   interviewMoreBtn.addEventListener("click", e => {
  //     e.preventDefault();

  //     const slides = document.querySelectorAll(".p-home__interview__cards .splide__slide");
  //     const hidden = Array.from(slides).filter(slide => window.getComputedStyle(slide).display === "none");

  //     hidden.slice(0, 4).forEach(slide => {
  //       u.fadeIn(slide, 300);
  //     });

  //     // 残りが0になったらボタンを非表示
  //     const remaining = Array.from(slides).filter(slide => window.getComputedStyle(slide).display === "none");
  //     if (remaining.length === 0) {
  //       interviewMoreBtn.closest(".p-home__interview-btn").style.display = "none";
  //     }
  //   });
  // }

  // digestもっとみるボタン（PC時：4件ずつ表示）
  // const digestMoreBtn = document.querySelector(".p-home__digest-btn a");
  // if (digestMoreBtn) {
  //   digestMoreBtn.addEventListener("click", e => {
  //     e.preventDefault();

  //     const slides = document.querySelectorAll(".p-home__digest__cards .splide__slide");
  //     const hidden = Array.from(slides).filter(slide => window.getComputedStyle(slide).display === "none");

  //     hidden.slice(0, 4).forEach(slide => {
  //       u.fadeIn(slide, 300);
  //     });

  //     // 残りが0になったらボタンを非表示
  //     const remaining = Array.from(slides).filter(slide => window.getComputedStyle(slide).display === "none");
  //     if (remaining.length === 0) {
  //       digestMoreBtn.closest(".p-home__digest-btn").style.display = "none";
  //     }
  //   });
  // }

  const cards3 = document.querySelector(".p-home__feature3__cards");
  if (cards3) {
    new Splide(cards3, {
      type: "loop",
      mediaQuery: "min",
      padding: "16.4102564102564vw",
      gap: "4.35897435897436vw",
      pagination: false,
      arrows: false,
      autoplay: true,
      breakpoints: {
        768: {
          padding: 0,
          gap: 19,
          arrows: true,
          perPage: 3,
          pagination: false,
        },
      },
    }).mount();
  }
});
